import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class TrainersStudentMetaModel extends FormMetaModel {
    constructor() {
      super('Your Profile', ROUTE_PATH.trainersGrid, ROUTE_PATH.trainersStudentForm,3, '', false, '', 'd-flex row align-items-center justify-content-center',' row align-items-start justify-content-start my-2 ms-auto');
    }
  
    override initProperties(): any {
      const formInfo = super.initProperties();
      const first_name = new SmMetaInputModel(
        'first_name',
        'first_name',
        'input',
        true,
        'col-12 col-md-4',
        1,
        1,
        'First Name',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        true,
        true,
        true,
        false,
        100,
        1
      );
      const last_name = new SmMetaInputModel(
        'last_name',
        'last_name',
        'input',
        true,
        'col-12 col-md-4',
        1,
        2,
        'Last Name',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        true,
        true,
        true,
        false,
        100,
        1
      );
  
      const email = new SmMetaInputModel(
        'email',
        'email',
        'input',
        true,
        'col-12 col-md-4 ',
        2,
        3,
        'Email ID',
        'text',
        '}',
        true,
        true,
        true,
        false,
        100,
        5
      );
      const mobile_number = new SmMetaInputModel(
        'mobile_number',
        'mobile_number',
        'input',
        true,
        'col-12 col-md-4 ',
        2,
        4,
        'Mobile Number',
        'text',
        '[0-9]',
        true,
        true,
        true,
        false,
        10,
        10
      );
  
      const category_id = new SmMetaSelectModel(
        'category_id',
        'category_id',
        'ng-select',
        true,
        'col-12 col-md-4 ',
        3,
        5,
        'Category',
        'select',
        '',
        true,
        true,
        true,
        false,
        0,
        0,
        false,
        [],
        'category_name',
        'id',
        true,
        
      );
  
  
      return {
        formInfo,
        first_name,
        last_name,
        email,
        mobile_number,
        category_id,
      };
    }
  }